import { Radio, Shield, Server, Building2, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { useLanguage } from '@/i18n/LanguageContext';

const TEKTELIC_IMAGE = "https://customer-assets.emergentagent.com/job_industrial-iot-4/artifacts/m59g09fr_macro-photo-1.png%20%281%29.jpeg";

export const TektelicSection = () => {
  const { t } = useLanguage();

  const features = [
    { icon: Shield, text: t('tektelic.feature1') },
    { icon: Server, text: t('tektelic.feature2') },
    { icon: Building2, text: t('tektelic.feature3') },
    { icon: Radio, text: t('tektelic.feature4') },
  ];

  return (
    <section id="infrastructure" className="py-20 md:py-32 bg-slate-50" data-testid="tektelic-section">
      <div className="container-0g">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Content */}
          <div>
            <p className="section-label">{t('tektelic.label')}</p>
            <h2 className="section-title mb-6">
              {t('tektelic.title')}{' '}
              <span className="text-teal-600">{t('tektelic.titleHighlight')}</span>
            </h2>
            <p className="text-lg text-slate-600 mb-8 leading-relaxed">
              {t('tektelic.description')}
            </p>

            {/* Features */}
            <div className="grid grid-cols-2 gap-4 mb-8">
              {features.map((feature, index) => {
                const Icon = feature.icon;
                return (
                  <div 
                    key={index} 
                    className="flex items-center space-x-3"
                    data-testid={`tektelic-feature-${index}`}
                  >
                    <div className="w-10 h-10 rounded-sm bg-slate-100 flex items-center justify-center">
                      <Icon className="h-5 w-5 text-teal-600" />
                    </div>
                    <span className="text-sm font-medium text-slate-700">{feature.text}</span>
                  </div>
                );
              })}
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Link to="/tektelic">
                <Button 
                  className="btn-primary"
                  data-testid="tektelic-cta"
                >
                  {t('tektelic.cta')}
                </Button>
              </Link>
              <Link 
                to="/tektelic#starter-kits"
                className="inline-flex items-center text-teal-600 font-medium hover:underline px-4 py-2"
              >
                {t('solutions.learnMore')}
                <ArrowRight className="h-4 w-4 ml-2" />
              </Link>
            </div>
          </div>

          {/* Image */}
          <Link to="/tektelic" className="relative group">
            <div className="relative rounded-sm overflow-hidden">
              <img
                src={TEKTELIC_IMAGE}
                alt="Tektelic LoRaWAN gateway deployed in the field"
                className="w-full h-[400px] lg:h-[500px] object-cover group-hover:scale-105 transition-transform duration-300"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-slate-900/30 via-transparent to-transparent" />
            </div>
            
            {/* Partner badge */}
            <div className="absolute top-6 right-6 bg-white/95 backdrop-blur-sm px-4 py-2 rounded-sm shadow-lg">
              <p className="text-xs text-slate-500 uppercase tracking-wider">{t('tektelic.partnerBadge')}</p>
              <p className="text-lg font-bold text-slate-900">TEKTELIC</p>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
};
